export default __webpack_public_path__ + "static/media/gopay.341f5893.png";